import useSWR from "swr";
import { fetcher, api as userApi } from "@api/_base";
import { API_MESSAGE } from "@const/api-messages.const";
import { composeQueryParams } from "@utils/query.utils";
import { ProductDisplayConfig } from "@interfaces/components/product-filters.interface";
import { getFilterQuery, getPageQuery } from "../products/_utils";
import {
  CmsCouponListResponse,
  CollectCouponDto,
  CouponType,
} from "@interfaces/dto/coupon.dto";
import { PartnerBanneResponse } from "@interfaces/dto/coupon.dto";

// List coupon in cms
export const useListCouponCms = ({
  customerId,
  productDisplayConfig,
}: {
  customerId: string | undefined;
  productDisplayConfig: ProductDisplayConfig;
}): CmsCouponListResponse => {
  let query: string | undefined = undefined;
  // require customerId
  if (customerId) {
    const queryCus = getFilterQuery({
      field: "customer_id",
      value: customerId,
      layer: 0,
    });
    // page
    const { pageSize, currentPage, sortBy } = productDisplayConfig;
    const queryPage = getPageQuery({
      sortBy: sortBy,
      pageSize: pageSize,
      currentPage: currentPage,
    });

    query = composeQueryParams([queryCus, queryPage]);
  } else {
    const { pageSize, currentPage, sortBy } = productDisplayConfig;
    const queryPage = getPageQuery({
      sortBy: sortBy,
      pageSize: pageSize,
      currentPage: currentPage,
    });
    query = composeQueryParams([queryPage]);
  }

  const { data, error, mutate } = useSWR(
    query ? `/nextapi/coupon/list?${query}` : undefined,
    fetcher
  );

  return {
    data: data,
    isLoading: !error && !data,
    error: error,
    mutate: mutate,
  };
};

// Colect Coupon in cms
export const collectCoupon = async (inputs: CollectCouponDto): Promise<any> => {
  try {
    const resp = await userApi.post(`/nextapi/coupon`, inputs);
    return {
      isOk: true,
      message: "เก็บคูปองสำเร็จ",
      data: resp.data,
    };
  } catch (error: any) {
    const errorMessage: string =
      error.response.data.message ?? API_MESSAGE.INTERNAL_ERROR;
    return { isOk: false, message: errorMessage };
  }
};

// History Coupon
export const useHistoryCoupon = ({
  customerId,
  productDisplayConfig,
  filterType,
}: {
  customerId: string | undefined;
  productDisplayConfig: ProductDisplayConfig;
  filterType: CouponType; 
}): CmsCouponListResponse => {
  let query: string | undefined = undefined;
  // require customerId
  if (customerId) {
    const queryCus = getFilterQuery({
      field: "customer_id",
      value: customerId,
      layer: 0,
    });

    //coupon type
    const queryType = getFilterQuery({
      field: "filter_type",
      value: filterType,
      layer: 1,
    });
    // page
    const { pageSize, currentPage, sortBy } = productDisplayConfig;
    const queryPage = getPageQuery({
      sortBy: sortBy,
      pageSize: pageSize,
      currentPage: currentPage,
    });

    query = composeQueryParams([queryCus, queryType, queryPage]);
  } 

  const { data, error, mutate } = useSWR(
    query ? `/nextapi/coupon/history?${query}` : undefined,
    fetcher
  );

  return {
    data: data,
    isLoading: !error && !data,
    error: error,
    mutate: mutate,
  };
};

// Partner Banner
export const usePartnerBanner = (): PartnerBanneResponse => {
  const { data, error, mutate } = useSWR("/nextapi/banner-sections/14", fetcher);

  return {
    data: data && data.length > 0 ? data[0] : undefined,
    isLoading: !error && !data,
    error: error,
    mutate: mutate,
  };
};
